import { db, auth } from "../util/firebase";
import { contractAddress, nebPay, neb, api } from "../util/nebulas";

export default {
    createGame ({ commit }, payload) {
        const item = payload.item;

        return new Promise((resolve, reject) => { 

            const args = "[\"" + item.answer + "\",\"" +  item.category + "\",\"" + item.maxGuess + "\"]";
            nebPay.call(contractAddress, 0, 'createGame', args, {
                listener: function(data) {
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    clearInterval(pollApi);

                                    api.getEventsByHash({ hash: data.txhash })
                                    .then(function(result) {

                                        let eventResponse = JSON.parse(result.events[0].data).CreateGame;       

                                        console.log('eventResponse', eventResponse)

                                        commit('addItem', { item: {
                                            id: eventResponse.id,
                                            answer: item.answer, 
                                            owner: eventResponse.owner,
                                            category: item.category,
                                            maxGuess: item.maxGuess
                                        }});

                                        resolve({ message: 'success' });

                                    })
                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error' });

                            });
                    }, 3000);
                }
            });
        
        });

    },

    playGame ({ commit }, payload) {
        const args = payload.args;

        return new Promise((resolve, reject) => { 

            nebPay.call(contractAddress, 0, 'playGame', args, {
                listener: function(data) {
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    clearInterval(pollApi);

                                    api.getEventsByHash({ hash: data.txhash })
                                    .then(function(result) {

                                        let eventResponse = JSON.parse(result.events[0].data).PlayGame;       
                                        commit('replaceItem', { item: eventResponse });

                                        resolve({ message: 'success' });

                                    })
                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error' });

                            });
                    }, 3000);
                }
            });
        
        })

    },

    initGames ({ commit }) {

        new Promise((resolve, reject) => {      
            const confessionArray = [];
            nebPay.simulateCall(contractAddress, 0, 'getGames', "", {
                listener: function(data) {
                    const items = JSON.parse(data.result);

                    // Add loading, after we know nebpay is available
                    commit('updateContentLoading', { contentLoading: true });

                    resolve({ items })

                }
            });
        
        }).then((response) => {
            commit('setItems', { items: response.items });
            commit('updateContentLoading', { contentLoading: false });
        });
       
    }

}



// WEBPACK FOOTER //
// ./src/store/actions.js